import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

const initialState = {
  listPartnerTracking: [],
  isGetPartnerTracking: false,
  isCreatePartnerTracking: false,
  isRemovePartnerTracking: false,
  total: 0,
};

export const partnerTrackingSlice = createSlice({
  name: "partner-tracking",
  initialState,
  reducers: {
    getPartnerTrackingRequest: (state) => {
      state.isGetPartnerTracking = true;
    },
    getPartnerTrackingSuccess: (state, { payload }) => {
      state.isGetPartnerTracking = false;
      state.listPartnerTracking = payload.data;
      state.total = payload.total;
    },
    getPartnerTrackingFailure: (state) => {
      state.isGetPartnerTracking = false;
    },
    createPartnerTrackingRequest: (state) => {
      state.isCreatePartnerTracking = true;
    },
    createPartnerTrackingSuccess: (state) => {
      state.isCreatePartnerTracking = false;
      state.total += 1;
      message.success("Create partner tracking successfully!");
    },
    createPartnerTrackingFailure: (state) => {
      state.isCreatePartnerTracking = false;
    },
    removePartnerTrackingsRequest: (state) => {
      state.isRemovePartnerTracking = true;
    },
    removePartnerTrackingsSuccess: (state, { payload }) => {
      state.isRemovePartnerTracking = false;
      state.listPartnerTracking = payload;
      state.total -= 1;
      message.success("Remove partner tracking successfully!");
    },
    removePartnerTrackingsFailure: (state) => {
      state.isRemovePartnerTracking = false;
    },
  },
});

export const {
  getPartnerTrackingRequest,
  getPartnerTrackingSuccess,
  getPartnerTrackingFailure,
  createPartnerTrackingRequest,
  createPartnerTrackingSuccess,
  createPartnerTrackingFailure,
  removePartnerTrackingsRequest,
  removePartnerTrackingsSuccess,
  removePartnerTrackingsFailure,
} = partnerTrackingSlice.actions;

export default partnerTrackingSlice.reducer;
